import _taggedTemplateLiteral from "@babel/runtime-corejs3/helpers/taggedTemplateLiteral";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _templateObject;
var _excluded = ["QueryVariables", "isOpen", "inputValue", "selectedItems", "multiple"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _setTimeout from "@babel/runtime-corejs3/core-js-stable/set-timeout";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
//@ts-nocheck
import { gql } from "@apollo/client";
import * as React from "react";
import DefaultSuggestionsPopper from "../../Fields/AutoComplete/DefaultSuggestionsPopper";
import { Query } from "@apollo/client/react/components";
import { jsx as _jsx } from "react/jsx-runtime";
export default function DefaultAsyncSuggestionsMenu(_ref) {
  var QueryVariables = _ref.QueryVariables,
    isOpen = _ref.isOpen,
    inputValue = _ref.inputValue,
    selectedItems = _ref.selectedItems,
    multiple = _ref.multiple,
    props = _objectWithoutProperties(_ref, _excluded);
  var nodeType = QueryVariables.nodeType,
    selectableIds = QueryVariables.selectableIds,
    extraParams = QueryVariables.extraParams;

  // Debounce the inputValue for GraphQL queries (500ms delay)
  var _React$useState = React.useState(inputValue),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    debouncedInputValue = _React$useState2[0],
    setDebouncedInputValue = _React$useState2[1];
  React.useEffect(function () {
    var timer = _setTimeout(function () {
      setDebouncedInputValue(inputValue);
    }, 500);
    return function () {
      clearTimeout(timer);
    };
  }, [inputValue]);
  return /*#__PURE__*/_jsx(Query, {
    query: SEARCH_QUERY,
    fetchPolicy: "cache-and-network",
    variables: {
      nodeType: nodeType,
      ids: [],
      searchBy: debouncedInputValue ? debouncedInputValue : undefined,
      selectableIds: selectableIds,
      excludedIds: multiple ? _mapInstanceProperty(selectedItems).call(selectedItems, function (node) {
        return node.id;
      }) : null,
      extraParams: extraParams ? _JSON$stringify(extraParams) : undefined
    },
    children: function children(_ref2) {
      var _ref2$data = _ref2.data,
        data = _ref2$data === void 0 ? {} : _ref2$data,
        refetch = _ref2.refetch,
        error = _ref2.error,
        loading = _ref2.loading;
      if (error) {
        console.error(error);
        return "Unable to load suggestions";
      }
      var suggestions = data.selectableNodes || [];
      return /*#__PURE__*/_jsx(DefaultSuggestionsPopper, _objectSpread({
        open: isOpen,
        suggestions: suggestions,
        inputValue: inputValue,
        selectedItems: selectedItems,
        loading: loading
      }, props));
    }
  });
}
export var SEARCH_QUERY = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query AsyncSelectSearchQuery(\n        $searchBy: String\n        $selectableIds: [UUID]\n        $excludedIds: [UUID]\n        $extraParams: JSONString\n        $nodeType: SelectableNodeEnum!\n    ) {\n        selectableNodes(\n            searchBy: $searchBy\n            first: 30\n            excludedIds: $excludedIds\n            ids: $selectableIds\n            extraParams: $extraParams\n            nodeType: $nodeType\n        ) {\n            id\n            displayLabel\n        }\n    }\n"])));